import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getDocuments as getDocumentsApi } from '../api/documentsApi'
import { HttpResponseStatusCodes } from '../constants'
import { DOCUMENT_RETRIEVAL_FAILED, TEMPORARILY_UNAVAILABLE } from './constants'

export const GET_DOCUMENTS = 'GET_DOCUMENTS'
export const GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS'
export const GET_DOCUMENTS_FAILURE = 'GET_DOCUMENTS_FAILURE'

export const getDocuments = (
  dispatch: Dispatch,
  accountNumber: string,
  documentTypes: string
) => {
  dispatch({ type: GET_DOCUMENTS })
  getDocumentsApi(accountNumber, documentTypes)
    .then((response: AxiosResponse) => {
      const documents = response.data
      dispatch({ type: GET_DOCUMENTS_SUCCESS, documents })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : DOCUMENT_RETRIEVAL_FAILED
      dispatch({ type: GET_DOCUMENTS_FAILURE, errorMessage })
    })
}
